import styled from 'styled-components';
import { themeColor } from '~/common/utils/theme';

export const RegistrationLogList = styled.div`
  overflow-y: auto;
  max-height: 66vh;

  & > *:not(:last-child) {
    padding-bottom: 13px;
    border-bottom: 1px dashed ${themeColor('divider.primary')};
    margin-bottom: 16px;
  }
`;

export const PopoverContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  max-width: 387px;
  max-height: 350px;
  height: 100vh;
  border-radius: 1rem;
  min-width: 290px;
`;

export const PopoverHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  align-items: center;

  .action-icon {
    cursor: pointer;
    color: ${themeColor('brand.primary', { dark: 'brand.primaryAlt' })};
  }
`;

export const PopoverTitle = styled.span`
  display: flex;
  font-size: 18px;
  font-weight: 700;
  color: ${themeColor('element.primary')};
`;

export const PopoverCloseAction = styled.div`
  display: flex;
  padding: 14px;
  background-color: ${themeColor('background.secondary')};
  border-radius: 12px;
  cursor: pointer;
`;

export const PopOverTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  overflow: auto;
  padding-right: 8px;
`;
export const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
`;
